// Skill ratings for learning skills and work habits (per course, per term).
export const skillOptions = [
  { value: 'E', label: 'E' },
  { value: 'G', label: 'G' },
  { value: 'S', label: 'S' },
  { value: 'N', label: 'N' },
  { value: '',  label: 'x' },
]
